import axios from 'axios';
import { authHeader } from './auth-header';
const API_URL = process.env.VUE_APP_BASE_API_URL;
const SecretKey = process.env.VUE_APP_SECRET_KEY;
const CryptoJS = require("crypto-js");

export const userService = {
    login,
    logout,
    verifyOtp,
    resendOtp,
    getAll,
    splitToken,
    setToken
};

function login(username, password) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    return fetch(`/users/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                setToken(user);
            }
            return user;
        });
}

function verifyOtp(data) {
    return axios.post(API_URL+'auth/two-factor-authentication/verify-otp', data);
}

function resendOtp(data) {
    return axios.post(API_URL+'auth/two-factor-authentication/resend-otp', data);
}

function setToken(user) {
    var today = new Date();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    // store user details and jwt token in local storage to keep user logged in between page refreshes
    localStorage.setItem('user', JSON.stringify(user.user));
    localStorage.setItem('id', CryptoJS.AES.encrypt(user.id, SecretKey));
    localStorage.setItem('rl', CryptoJS.AES.encrypt(user.role, SecretKey));
    localStorage.setItem('lang', 'en');
    localStorage.setItem('theme','dark');

    localStorage.setItem('time', time);
    splitToken(user.token);
}

function splitToken(token) {
    let splitToken = token.split(".");
    let storeToken = splitToken[1] + "." + splitToken[2];
    localStorage.setItem('token', CryptoJS.AES.encrypt(storeToken, SecretKey).toString());
}

function logout() {
    // remove user from local storage to log user 
    console.log('logout system');
    axios.get(API_URL+'auth/logout', {headers: authHeader() })
          .then((response) => {
            if (response.status == 201) {
              let new_token = response.data.refresh_access_token;
              splitToken(new_token)
              this.logout();
            } else {
                localStorage.removeItem('user');
                localStorage.removeItem('token');
                localStorage.removeItem('theme');
                localStorage.removeItem('username');
                localStorage.removeItem('rl');
                localStorage.removeItem('id');
                localStorage.removeItem('tfa_key');
            }
        })
        .catch((err) => {
            window.location.replace('/')
             if (err.response.status == 401) {
                localStorage.removeItem('user');
                localStorage.removeItem('token');
                localStorage.removeItem('theme');
                localStorage.removeItem('username');
                localStorage.removeItem('rl');
                localStorage.removeItem('id');
                localStorage.removeItem('tfa_key');
            }
          });
    
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('theme');
        localStorage.removeItem('username');
        localStorage.removeItem('rl');
        localStorage.removeItem('id');
        localStorage.removeItem('tfa_key');
}


function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}